module.exports = __webpack_public_path__ + "ky.svg?18cdf70ca61438766035963454b590bf";